import { render, staticRenderFns } from "./TestPackageGroupServerTable.vue?vue&type=template&id=2b32ae6b"
import script from "./TestPackageGroupServerTable.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports